import { cn } from "@/lib/utils";
import { XIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "./button";
import { Command, CommandInput } from "./command";

type SearchBarProps = {
  className?: string;
  placeholder?: string;
  onChangeSearch?: (search: string) => void;
  search: string;
};

const SearchBar = ({
  className,
  placeholder,
  onChangeSearch,
  search,
}: SearchBarProps) => {
  const { t } = useTranslation();

  const onChange = (value: string) => {
    onChangeSearch?.(value);
  };

  return (
    <div className={cn(`relative flex justify-end ${className}`)}>
      <Command shouldFilter={false} className="border rounded-md">
        <CommandInput
          placeholder={placeholder ?? t("search")}
          value={search}
          onValueChange={onChange}
        />
        {search && (
          <Button
            variant="ghost"
            size="sm"
            className="absolute right-2 top-1/2 transform -translate-y-1/2 p-1"
            onClick={() => onChange("")}
          >
            <XIcon className="w-4 h-4 text-muted-foreground" />
          </Button>
        )}
      </Command>
    </div>
  );
};

export default SearchBar;
